export type SoundName = 'message' | 'direct' | 'mention' | 'sent' | 'deviceRequest'

export const SOUND_NAMES: readonly SoundName[] = ['message', 'direct', 'mention', 'sent', 'deviceRequest']

/** Files in public/sounds. Replace the files (same names) to change the sounds; see public/sounds/README.md. */
export const CLIP_URLS: Record<SoundName, string> = {
  message: '/sounds/message.wav',
  direct: '/sounds/direct.wav',
  mention: '/sounds/mention.wav',
  sent: '/sounds/sent.wav',
  deviceRequest: '/sounds/device-request.wav',
}

export const SOUND_LABELS: Record<SoundName, { label: string; help: string }> = {
  message: { label: 'Channel messages', help: 'In channels set to notify about all messages.' },
  direct: { label: 'Direct messages', help: 'One-to-one and group conversations.' },
  mention: { label: 'Mentions', help: 'When someone @mentions you.' },
  sent: { label: 'Message sent', help: 'A quiet confirmation when your message is delivered.' },
  deviceRequest: { label: 'Device approval requests', help: 'When a device is waiting for approval.' },
}
